export default __webpack_public_path__ + "static/media/message-square.bd232030.svg";